import { computed, type Resource, type Signal } from '@angular/core';

export function anyResourceIsLoading(...resources: Resource<unknown>[]) {
  return computed(() => resources.some((r) => r.isLoading()));
}

export function anyResourceHasError(...resources: Resource<unknown>[]) {
  return computed(() => resources.some((r) => r.error()));
}

export function allResourcesHaveValue(...resources: Resource<unknown>[]) {
  return computed(() => resources.every((r) => r.hasValue()));
}

export function resourceValueSafe<T>(resource: Resource<T>): Signal<T | undefined>;
export function resourceValueSafe<T>(resource: Resource<T>, fallbackValue: T): Signal<T>;
export function resourceValueSafe<T>(resource: Resource<T>, fallbackValue?: T): Signal<T | undefined> {
  return computed(() => {
    if (resource.error()) {
      return fallbackValue;
    }

    return resource.value();
  });
}
